import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  DeleteVesselContactDetails,
  VesselContactDetailsType,
  Visit
} from "@portbase/bezoekschip-service-typescriptmodels";
import {Handler} from "../../../common/handlers/handler";
import {View} from "../../../common/handlers/view";
import {sendCommand, sendQuery} from "../../../common/utils";
import {isEmpty} from "lodash";
import {Observable} from "rxjs";
import {AppContext} from "../../../app-context";
import {map} from "rxjs/operators";


@Component({
  selector: 'vessel-communication-component',
  templateUrl: './vessel-communication-details.component.html',
  styleUrls: ['./vessel-communication-details.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
@Handler()
export class VesselCommunicationComponent extends View implements OnInit {
  @Input() visit!: Visit;
  @Input() label!: string;
  @Input() type!: VesselContactDetailsType;

  selectedDetails: { details: string };
  isNotAPonton;

  protected readonly isEmpty = isEmpty;

  ngOnInit() {
    const initial = this.getVisitDeclarationValue();
    if (initial) {
      this.selectedDetails = {details: initial};
    }
    let statCode5 = this.visit.vessel.statCode5?.toUpperCase();
    let isPonton = false;
    if (statCode5) {
      isPonton = statCode5.startsWith('Y11') || statCode5.startsWith('Z11');
      if (statCode5.startsWith('Z11A')) {
        isPonton = false;
      }
    }
    this.isNotAPonton = !isPonton;
  }

  private getVisitDeclarationValue(): string {
    return this.type === VesselContactDetailsType.EMAIL
      ? this.visit.visitDeclaration.vesselEmailAddress
      : this.visit.visitDeclaration.vesselPhoneNumber;
  }

  private setVisitDeclarationValue(value: string): void {
    if (this.type === VesselContactDetailsType.EMAIL) {
      this.visit.visitDeclaration.vesselEmailAddress = value;
    } else {
      this.visit.visitDeclaration.vesselPhoneNumber = value;
    }
  }

  findVesselContactDetails = (term: string): Observable<{ details: string }[]> => {
    return sendQuery(
      "com.portbase.bezoekschip.common.api.visit.vesselcontactdetails.GetVesselContactDetails",
      {
        imoCode: this.visit.vessel.imoCode,
        agentShortName: this.visit.originalDeclarant.shortName
      },
      {caching: false}
    ).pipe(
      map(contactDetails => {
        const list = this.type === VesselContactDetailsType.PHONE ? contactDetails?.phoneNumbers : contactDetails?.emailAddresses;
        return list
          ?.filter((item): item is string => typeof item === 'string')
          .filter(item => item.startsWith(term))
          .map(value => ({details: value})) ?? [];
      })
    );
  }

  onCommunicationDetailChange = (value: { details: string }) => {
    if (value == null) {
      this.setVisitDeclarationValue("");
    } else {
      this.setVisitDeclarationValue(value.details);
    }
  };

  communicationFormatter = (value: { details: string }) => value.details;

  deleteContactDetails = (details: { details: string }): void => {
    sendCommand("com.portbase.bezoekschip.common.api.visit.vesselcontactdetails.DeleteVesselContactDetails", <DeleteVesselContactDetails>{
      agentShortName: this.visit.originalDeclarant.shortName,
      contactDetailsToDelete: details.details,
      imoCode: this.visit.vessel.imoCode,
      type: this.type
    }, () => {
      AppContext.registerSuccess(`Successfully deleted contact details ${details.details}`);
    });
  }
}
